export const translations = {
  en: {
    brand: "DialectStudio",
    tagline: "AI content, built for Arabic & Kurdish creators",
    nav_home: "Home",
    nav_scripts: "Story Studio",
    nav_prompts: "AI Prompts",
    nav_contact: "Contact",
    hero_eyebrow: "Creator Studio · العربية · کوردی",
    hero_title_1: "Ready-to-use scripts &",
    hero_title_2: "AI prompts in your dialect",
    hero_sub: "Stop staring at a blank screen. Grab viral TikTok scripts, AI image prompts and content ideas — crafted for Arabic and Kurdish dialects.",
    hero_cta: "Browse the library",
    hero_cta2: "Generate with AI",
    explore: "Explore categories",
    explore_sub: "Three toolkits to fuel every post you make.",
    featured: "Fresh from the library",
    featured_sub: "Hand-picked scripts, prompts and ideas across dialects.",
    view_all: "View all",
    filter_dialect: "Dialect",
    all_dialects: "All dialects",
    copy: "Copy",
    copied: "Copied to clipboard!",
    generate_title: "AI Generator",
    generate_desc: "Pick a category, dialect and topic — get fresh content in seconds.",
    field_category: "Category",
    field_dialect: "Dialect",
    field_topic: "Topic",
    field_topic_ph: "e.g. morning routine, coffee shop, fitness…",
    field_vibe: "Vibe",
    btn_generate: "Generate",
    generating: "Generating…",
    result: "Your generated content",
    empty: "No content found for this filter yet.",
    ad_label: "ADVERTISEMENT",
    ad_sponsored: "Sponsored",
    ad_your: "Your ad here",
    contact_title: "Contact Us",
    contact_sub: "Questions, dialect requests or partnership ideas? Send us a message.",
    c_name: "Name",
    c_email: "Email",
    c_topic: "Topic",
    c_topic_ph: "Select a topic",
    c_topic_general: "General question",
    c_topic_dialect: "Request a dialect",
    c_topic_partner: "Partnership / Ads",
    c_topic_bug: "Report an issue",
    c_dialect: "Preferred dialect (optional)",
    c_message: "Message",
    c_message_ph: "Tell us how we can help…",
    c_send: "Send message",
    c_sending: "Sending…",
    c_success: "Thanks! We'll get back to you soon.",
    footer_tag: "Fuel for Arabic & Kurdish creators.",
    footer_rights: "All rights reserved.",
    vibe_viral: "Viral", vibe_funny: "Funny", vibe_emotional: "Emotional",
    vibe_educational: "Educational", vibe_cinematic: "Cinematic",
    pg_title: "Instant Prompt Generator",
    pg_desc: "Type a simple idea and get a pro Midjourney / Flux prompt in seconds.",
    pg_ph: "e.g. I want a picture in Iraq at sunset…",
    pg_btn: "Generate Prompt",
    pg_result: "Your pro prompt",
  },
  ar: {
    brand: "ديالكت ستوديو",
    tagline: "محتوى بالذكاء الاصطناعي لصنّاع العربية والكردية",
    nav_home: "الرئيسية",
    nav_scripts: "استوديو القصص",
    nav_prompts: "برومبتات AI",
    nav_contact: "تواصل معنا",
    hero_eyebrow: "استوديو المبدعين · العربية · کوردی",
    hero_title_1: "سيناريوهات جاهزة و",
    hero_title_2: "برومبتات ذكاء اصطناعي بلهجتك",
    hero_sub: "بطّل تبصّ في شاشة فاضية. خُد سيناريوهات تيك توك فيرال، برومبتات صور بالذكاء الاصطناعي، وأفكار محتوى مصممة للهجات العربية والكردية.",
    hero_cta: "تصفّح المكتبة",
    hero_cta2: "أنشئ بالذكاء الاصطناعي",
    explore: "استكشف الأقسام",
    explore_sub: "ثلاث أدوات تشغّل كل بوست بتعمله.",
    featured: "جديد من المكتبة",
    featured_sub: "سيناريوهات وبرومبتات وأفكار مختارة بعناية عبر اللهجات.",
    view_all: "عرض الكل",
    filter_dialect: "اللهجة",
    all_dialects: "كل اللهجات",
    copy: "نسخ",
    copied: "تم النسخ!",
    generate_title: "مولّد الذكاء الاصطناعي",
    generate_desc: "اختر القسم واللهجة والموضوع — واحصل على محتوى جديد في ثوانٍ.",
    field_category: "القسم",
    field_dialect: "اللهجة",
    field_topic: "الموضوع",
    field_topic_ph: "مثال: روتين الصباح، محل قهوة، رياضة…",
    field_vibe: "الطابع",
    btn_generate: "أنشئ",
    generating: "جارٍ الإنشاء…",
    result: "المحتوى الذي تم إنشاؤه",
    empty: "لا يوجد محتوى لهذا الفلتر بعد.",
    ad_label: "إعلان",
    ad_sponsored: "مموّل",
    ad_your: "إعلانك هنا",
    contact_title: "تواصل معنا",
    contact_sub: "أسئلة، طلب لهجة، أو أفكار شراكة؟ ابعتلنا رسالة.",
    c_name: "الاسم",
    c_email: "البريد الإلكتروني",
    c_topic: "الموضوع",
    c_topic_ph: "اختر موضوعًا",
    c_topic_general: "سؤال عام",
    c_topic_dialect: "طلب لهجة",
    c_topic_partner: "شراكة / إعلانات",
    c_topic_bug: "الإبلاغ عن مشكلة",
    c_dialect: "اللهجة المفضّلة (اختياري)",
    c_message: "الرسالة",
    c_message_ph: "قلّنا نقدر نساعدك بإيه…",
    c_send: "إرسال الرسالة",
    c_sending: "جارٍ الإرسال…",
    c_success: "شكراً! هنرد عليك قريب.",
    footer_tag: "وقود لصنّاع المحتوى بالعربية والكردية.",
    footer_rights: "جميع الحقوق محفوظة.",
    vibe_viral: "فيرال", vibe_funny: "كوميدي", vibe_emotional: "عاطفي",
    vibe_educational: "تعليمي", vibe_cinematic: "سينمائي",
    pg_title: "مولّد البرومبت الفوري",
    pg_desc: "اكتب فكرة بسيطة واحصل على برومبت احترافي لميدجورني / فلكس في ثوانٍ.",
    pg_ph: "مثال: عايز صورة في العراق وقت الغروب…",
    pg_btn: "أنشئ البرومبت",
    pg_result: "برومبتك الاحترافي",
  },
  ku: {
    brand: "دیالێکت ستۆدیۆ",
    tagline: "ناوەڕۆکی AI بۆ داهێنەرانی عەرەبی و کوردی",
    nav_home: "سەرەتا",
    nav_scripts: "ستۆدیۆیا چیرۆکان",
    nav_prompts: "پرۆمپتی AI",
    nav_contact: "پەیوەندی",
    hero_eyebrow: "ستۆدیۆی داهێنەران · العربية · کوردی",
    hero_title_1: "سکریپتی ئامادە و",
    hero_title_2: "پرۆمپتی AI بە زاراوەی خۆت",
    hero_sub: "چیتر تەماشای شاشەی بەتاڵ مەکە. سکریپتی ڤایراڵی تیک تۆک، پرۆمپتی وێنەی AI و بیرۆکەی ناوەڕۆک وەربگرە — دروستکراو بۆ زاراوەکانی عەرەبی و کوردی.",
    hero_cta: "گەڕان بەناو کتێبخانە",
    hero_cta2: "دروستکردن بە AI",
    explore: "بەشەکان بگەڕێ",
    explore_sub: "سێ ئامراز بۆ هەموو پۆستێکت.",
    featured: "نوێ لە کتێبخانە",
    featured_sub: "سکریپت و پرۆمپت و بیرۆکەی هەڵبژێردراو بەپێی زاراوە.",
    view_all: "بینینی هەموو",
    filter_dialect: "زاراوە",
    all_dialects: "هەموو زاراوەکان",
    copy: "کۆپی",
    copied: "کۆپی کرا!",
    generate_title: "دروستکەری AI",
    generate_desc: "بەش و زاراوە و بابەت هەڵبژێرە — ناوەڕۆکی نوێ لە چەند چرکەیەکدا.",
    field_category: "بەش",
    field_dialect: "زاراوە",
    field_topic: "بابەت",
    field_topic_ph: "نموونە: ڕۆتینی بەیانی، کافێ، وەرزش…",
    field_vibe: "کەشوهەوا",
    btn_generate: "دروستبکە",
    generating: "دروستکردن…",
    result: "ناوەڕۆکی دروستکراوت",
    empty: "هێشتا هیچ ناوەڕۆکێک بۆ ئەم فلتەرە نییە.",
    ad_label: "ڕیکلام",
    ad_sponsored: "پاڵپشتیکراو",
    ad_your: "ڕیکلامەکەت لێرە",
    contact_title: "پەیوەندیمان پێوە بکە",
    contact_sub: "پرسیار، داواکاری زاراوە، یان بیرۆکەی هاوبەشی؟ پەیامێکمان بۆ بنێرە.",
    c_name: "ناو",
    c_email: "ئیمەیل",
    c_topic: "بابەت",
    c_topic_ph: "بابەتێک هەڵبژێرە",
    c_topic_general: "پرسیاری گشتی",
    c_topic_dialect: "داواکاری زاراوە",
    c_topic_partner: "هاوبەشی / ڕیکلام",
    c_topic_bug: "ڕاپۆرتی کێشە",
    c_dialect: "زاراوەی دڵخواز (ئارەزوومەندانە)",
    c_message: "پەیام",
    c_message_ph: "پێمان بڵێ چۆن یارمەتیت بدەین…",
    c_send: "ناردنی پەیام",
    c_sending: "دەنێردرێت…",
    c_success: "سوپاس! بەم زووانە وەڵامت دەدەینەوە.",
    footer_tag: "سووتەمەنی بۆ داهێنەرانی عەرەبی و کوردی.",
    footer_rights: "هەموو مافەکان پارێزراون.",
    vibe_viral: "ڤایراڵ", vibe_funny: "پێکەنیناوی", vibe_emotional: "هەستیار",
    vibe_educational: "فێرکاری", vibe_cinematic: "سینەمایی",
    pg_title: "دروستکەری خێرای پرۆمپت",
    pg_desc: "بیرۆکەیەکی سادە بنووسە و لە چەند چرکەیەکدا پرۆمپتی پیشەیی میدجەرنی / فلەکس وەربگرە.",
    pg_ph: "نموونە: وێنەیەکم دەوێت لە عێراق لە کاتی ئاوابوون…",
    pg_btn: "پرۆمپت دروستبکە",
    pg_result: "پرۆمپتە پیشەییەکەت",
  },
};

export const LANGS = [
  { code: "en", label: "EN", name: "English" },
  { code: "ar", label: "ع", name: "العربية" },
  { code: "ku", label: "ک", name: "کوردی" },
];
